import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		//引入全局变量文件
	},

	state: {
		//属性
		sessionId: '',
		MenuPermission: '',
		userInfo: {},
		lng: '',
		lat: '',
		//postUrl: 'https://www.sfrsafety.com:8443',
		//postUrl: 'http://www.sfrsafety.com:8091',
		postUrl: 'https://www.yizhi1996.com:8443',
		//postUrl: 'http://114.115.209.185:8091',
		//postUrl: 'http://10.200.0.16:8091',
		//postUrl: 'http://localhost:8098',
	},

	getters: {
		//这里是get方法
		getPostUrl: state => state.postUrl,
		getSessionId: state => state.sessionId,
		getUserInfo: state => state.userInfo,
		getMenuPermission: state => state.MenuPermission,
		getLng: state => state.lng,
		getLat: state => state.lat,
	},
	mutations: {
		//这里是set方法
		setSessionId(state, sessionId) {
			state.sessionId = sessionId
		},
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo
		},
		setMenuPermission(state, menu) {
			state.MenuPermission = menu
		},
		setLng(state, lng) {
			state.lng = lng
		},
		setLat(state, lat) {
			state.lat = lat
		}
	},
	actions: {
		//这个部分我暂时用不上
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js